var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--mypage"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("작품검색")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('auction-search-filter', _vm._b({}, 'auction-search-filter', {
    keyword: _vm.keyword
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "mb-20 mb-md-30"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify-md": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "mb-4 mb-md-0"
  }, [_c('span', {
    staticClass: "font-size-16 grey-68--text"
  }, [_vm._v(" " + _vm._s(_vm.keyword ? "".concat(_vm.keyword, "\uC5D0 \uB300\uD55C") : "전체") + " 검색결과 "), _c('span', {
    staticClass: "font-weight-bold primary--text"
  }, [_vm._v(_vm._s(_vm.totalCount))]), _vm._v("건 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('auction-search-sort', _vm._b({}, 'auction-search-sort', {
    totalCount: _vm.totalCount
  }, false))], 1)], 1)], 1), _c('v-divider', {
    staticClass: "primary"
  }), _vm._l(_vm.works, function (work) {
    return [_c('auction-search-item', {
      key: work._id,
      attrs: {
        "work": work
      }
    }), _c('v-divider', {
      key: "".concat(work._id, "-divider"),
      staticClass: "grey-da"
    })];
  }), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _this.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)], 2)], 1)], 1), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }